import { initializeApp } from "firebase/app";
import { getFirebaseConfig, isLocalhost, firebaseEmulatorHost } from "../config";
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from "firebase/auth";
// Initialize Firebase App
const app = initializeApp(getFirebaseConfig());
const googleAuthProvider = new GoogleAuthProvider();
const auth = getAuth(app);
if (isLocalhost) {
    connectAuthEmulator(auth, firebaseEmulatorHost);
}
export { auth, googleAuthProvider };
